/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'creditcard': {
    width: 16,
    height: 16,
    viewBox: '0 0 32 23',
    data: '<path pid="0" d="M29 23c.83 0 1.54-.3 2.13-.88.58-.58.87-1.29.87-2.12V3c0-.83-.3-1.54-.88-2.13A2.9 2.9 0 0029 0H3C2.17 0 1.46.3.87.88A2.9 2.9 0 000 3v17c0 .83.3 1.54.88 2.13.58.58 1.29.87 2.12.87h26zm1-17H2V3c0-.27.1-.5.3-.7.2-.2.43-.3.7-.3h26c.27 0 .5.1.7.3.2.2.3.43.3.7v3zm-1 15H3c-.27 0-.5-.1-.7-.3A.96.96 0 012 20V10h28v10c0 .27-.1.5-.3.7-.2.2-.43.3-.7.3z"/>'
  }
})
